// IndividualCompetenceTable.jsx
import React, { useMemo } from "react";
import { Table } from "antd";
import './individualCompetenceTable.css';

const formatNumber = (val, digits = 1) => {
    const n = Number(val);
    return Number.isFinite(n) ? n.toFixed(digits) : "-";
};

const IndividualCompetenceTable = ({ competence = {}, redLight = 60, yellowLight = 80 }) => {
    const { subdimensions = [] } = competence;
    const subs = Array.isArray(subdimensions) ? subdimensions : [];

    const getColor = (value) => {
        if (!Number.isFinite(value)) return "transparent";
        if (value <= redLight) return "#e53935";
        if (value <= yellowLight) return "#fbc02d";
        return "#43a047";
    };

    const getContrastTextColor = (bgColor) =>
        String(bgColor).toLowerCase() === '#fbc02d' ? '#000' : '#fff';

    const relationships = useMemo(() => {
        const rels = new Set();
        subs.forEach((sub) => {
            const avrByRel = sub?.average_by_relationship || {};
            Object.keys(avrByRel).forEach((r) => rels.add(r));
        });
        return Array.from(rels);
    }, [subs]);

    const columns = [
        {
            title: <span style={{ fontSize: "10px" }}>PREGUNTA</span>,
            dataIndex: "questionNumber",
            key: "questionNumber",
            fixed: "left",
            width: 80,
            render: (val) => <span style={{ fontSize: "10px" }}>{val}</span>,
        },
        ...relationships.map((rel) => ({
            title: <span style={{ fontSize: "10px" }}>{rel}</span>,
            dataIndex: rel,
            key: rel,
            align: "center",
            render: (val) => (
                (() => {
                    const bgColor = getColor(val);
                    const textColor = getContrastTextColor(bgColor);
                    return (
                <div
                    style={{
                        backgroundColor: bgColor,
                        color: textColor,
                        fontSize: "10px",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        display: "inline-block",
                        minWidth: "35px",
                    }}
                >
                    {formatNumber(val, 1)}
                </div>
                    );
                })()
            ),
        })),
        {
            title: <span style={{ fontSize: "10px" }}>PROM.</span>,
            dataIndex: "average",
            key: "average",
            align: "center",
            render: (val) => (
                (() => {
                    const bgColor = getColor(val);
                    const textColor = getContrastTextColor(bgColor);
                    return (
                <div
                    style={{
                        backgroundColor: bgColor,
                        color: textColor,
                        fontSize: "10px",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        display: "inline-block",
                        minWidth: "35px",
                    }}
                >
                    {formatNumber(val, 1)}
                </div>
                    );
                })()
            ),
        },
        {
            title: <span style={{ fontSize: "10px" }}>PROM. SIN AE</span>,
            dataIndex: "another",
            key: "another",
            align: "center",
            render: (val) => (
                (() => {
                    const bgColor = getColor(val);
                    const textColor = getContrastTextColor(bgColor);
                    return (
                <div
                    style={{
                        backgroundColor: bgColor,
                        color: textColor,
                        fontSize: "10px",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        display: "inline-block",
                        minWidth: "35px",
                    }}
                >
                    {formatNumber(val, 1)}
                </div>
                    );
                })()
            ),
        },
    ];

    const data = subs.map((sub, idx) => {
        const row = {
            key: `rel-${idx}`,
            questionNumber: `Pregunta ${idx + 1}`,
            average: Number(sub.average),
            another: Number(sub.another),
        };

        relationships.forEach((rel) => {
            const v = sub?.average_by_relationship?.[rel];
            row[rel] = Number.isFinite(Number(v)) ? Number(v) : undefined;
        });

        return row;
    });

    return (
        <Table
            className="table-individual-competence"
            columns={columns}
            dataSource={data}
            bordered
            pagination={false}
            size="small"
        />
    );
};

export default IndividualCompetenceTable;
